// I-270 outer beltway + ~0.5 mi buffer polygon for Columbus, OH.
// Generated from OpenStreetMap relation 123301 (the actual I-270 OH highway
// data). 1872 GPS nodes were extracted from the OSM mainline ways, sorted by
// polar angle from the highway centroid (39.99°N, 82.99°W), reduced to the
// outermost point per 4.5° sector, buffered outward 0.5 mi, and downsampled to
// 32 evenly-spaced vertices. Direction is counter-clockwise starting from the
// west side. Each entry is [lat, lng].
export const I270_POLYGON = [
  [39.9796, -83.1285],
  [39.95693, -83.12847],
  [39.9248, -83.13185],
  [39.91073, -83.11843],
  [39.89783, -83.07854],
  [39.89299, -83.05819],
  [39.87594, -83.02519],
  [39.86812, -83.00691],
  [39.86576, -82.97727],
  [39.86507, -82.95708],
  [39.86729, -82.92327],
  [39.87504, -82.91369],
  [39.9033, -82.88498],
  [39.91757, -82.8663],
  [39.93836, -82.83825],
  [39.95702, -82.83415],
  [39.99543, -82.84657],
  [40.00889, -82.86889],
  [40.03418, -82.89473],
  [40.05585, -82.89443],
  [40.08781, -82.90111],
  [40.10245, -82.90669],
  [40.11039, -82.93631],
  [40.11447, -82.95664],
  [40.11852, -82.99644],
  [40.1189, -83.01794],
  [40.1183, -83.05201],
  [40.11612, -83.07727],
  [40.11203, -83.12893],
  [40.10127, -83.14372],
  [40.04237, -83.13446],
  [40.02415, -83.13093],
];

// Bounding box used by SVG projection helpers (matches polygon extents)
export const I270_BOUNDS = {
  north: 40.125,
  south: 39.860,
  east: -82.825,
  west: -83.150,
};

/**
 * Project (lat, lng) -> SVG (x, y) inside a viewBox of `width` x `height`.
 * Useful for static SVG illustrations (HowItWorks page).
 */
export function projectToSvg(lat, lng, width = 320, height = 320, padding = 30) {
  const { north, south, east, west } = I270_BOUNDS;
  const x =
    padding + ((lng - west) / (east - west)) * (width - padding * 2);
  // Latitude maps inverted (north is up = y small)
  const y =
    padding + ((north - lat) / (north - south)) * (height - padding * 2);
  return [x, y];
}

export const I270_SVG_POINTS = (width = 320, height = 320, padding = 30) =>
  I270_POLYGON
    .map(([lat, lng]) => projectToSvg(lat, lng, width, height, padding).map(n => n.toFixed(1)).join(","))
    .join(" ");
